import { useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { createQueryClient } from '@/api'
import { I18nProvider } from '@/i18n'
import { ToastProvider } from '@/ui'
import { AuthProvider } from '@/auth/AuthProvider'
import { AppErrorBoundary } from './ErrorBoundary'
import { router } from './router'

export function App() {
  const [queryClient] = useState(createQueryClient)
  return (
    <I18nProvider>
      <AppErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </ToastProvider>
        </QueryClientProvider>
      </AppErrorBoundary>
    </I18nProvider>
  )
}
